import React, { useState, useEffect } from "react";
import connectUserAndChat, { User } from "~/common/Store/connectUserAndChat";

interface Props {
  user: User;
}

export default connectUserAndChat(function HelpEmail({ user }: Props) {
  const isPlatinum = user.platinum.enabled;
  const emailAddress = isPlatinum
    ? "platinum@webstaurantstore.com"
    : "/ask.html";
  const [urlPath, setUrlPath] = useState("");

  useEffect(() => {
    setUrlPath(window.location.pathname);
  }, []);

  const EmailUs = () => (
    <div className="help__block">
      <p className="help__subject">
        <i className="help__icon icon-mail" />
        Email us your questions at
        <br />
        <b>
          <a href={`mailto:${emailAddress}`} className="underline">
            WebstaurantStore Platinum
          </a>
        </b>
      </p>
    </div>
  );

  const AskAQuestion = () => (
    <div className="help__block">
      <p className="help__subject">
        <i className="help__icon icon-mail" />
        <b>
          <a href={emailAddress} className="underline">
            Ask a question
          </a>
        </b>
      </p>
    </div>
  );

  return (
    <>
      {isPlatinum ? <EmailUs /> : urlPath !== "/ask.html" && <AskAQuestion />}
    </>
  );
});
